import {
	Box,
	Checkbox,
	Chip,
	FormControl,
	Input,
	InputLabel,
	ListItemText,
	MenuItem,
	Select,
	type Theme,
	useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import { searchProfiles } from "../../../profiles/ProfilesPage";
import { Profile } from "../../../profiles/models/Profile";

const getStyles = (profileId: number, profiles: Profile[], theme: Theme) => {
	return {
		fontWeight: !!profiles.find((p) => p.ProfileId === profileId)
			? theme.typography.fontWeightRegular
			: theme.typography.fontWeightMedium,
	};
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

type Props = {
	value: number[];
	onChange: Function;
	userIdForDelete: number | null;
	setprofileError: (err: string) => void;
	disabled?: boolean;
};

export const ProfilesPicker = ({
	value,
	onChange,
	userIdForDelete,
	setprofileError,
	disabled,
}: Props) => {
	const theme = useTheme();

	const [error, setError] = useState("");

	const { data: profiles, isLoading, isError, error: e } = searchProfiles();

	function getProfileNameById(profileId: number) {
		return (
			profiles
				?.find((p) => p.ProfileId === profileId)
				?.ProfileName.replaceAll("Profile", "") || ""
		);
	}

	useEffect(() => {
		if (e && isError) {
			setError(e.message);
		}
	}, [e, isError]);

	return (
		<Box
			sx={{
				"& .MuiSelect-select": {
					height: "auto",
					minHeight: "40px",
				},
			}}
		>
			{!isLoading && profiles?.length ? (
				<FormControl disabled={disabled} fullWidth>
					<InputLabel
						id="demo-mutiple-chip-label"
						style={
							value.length
								? { display: "flex", alignItems: "center" }
								: { display: "flex", alignItems: "center", marginTop: 10 }
						}
					>
						Profiles
					</InputLabel>
					<Select
						autoWidth={true}
						labelId="demo-mutiple-chip-label"
						id="demo-mutiple-chip"
						multiple
						value={value}
						onChange={onChange as any}
						input={<Input />}
						renderValue={(selected) => (
							<Box
								sx={{
									display: "flex",
									flexWrap: "wrap",
								}}
							>
								{(selected as number[]).map((profileId) => (
									<Chip
										key={`selected-profile-${profileId}`}
										label={getProfileNameById(profileId)}
										size="medium"
										sx={{ mx: 0.5 }}
									/>
								))}
							</Box>
						)}
						MenuProps={MenuProps}
					>
						{profiles.map((profile) => (
							<MenuItem
								key={`profile-${profile.ProfileId}`}
								value={profile.ProfileId as number}
								style={getStyles(profile.ProfileId as number, profiles, theme)}
							>
								<Checkbox
									checked={value.includes(profile.ProfileId as number)}
									size="small"
									color="primary"
								/>
								<ListItemText
									primary={profile.ProfileName.replaceAll("Profile", "")}
								/>
							</MenuItem>
						))}
					</Select>
				</FormControl>
			) : (
				<></>
			)}
			<ErrorModal error={error} onHide={() => setError("")} />
		</Box>
	);
};
